import moment from 'moment';
// require('moment/locale/ru');

import config from '../config';
import { memoize } from 'lodash';

moment.locale('ru');

moment.fromServerDatetime = function (datetime) {
  return datetime ? moment(datetime, config.serverDatetimeFormat) : null;
};

moment.fromServerFullDatetime = function (datetime) {
  return moment(datetime, config.fullServerDateTimeFormat);
};

moment.fromFullDatetime = function (datetime) {
  return moment(datetime, config.fullDateTimeFormat);
};

moment.toServerDateTime = function (datetime) {
  return moment.isMoment(datetime) ? datetime.defaultServerFormat() : datetime;
};

moment.fn.defaultFormat = function () {
  return this.format(config.datetimeFormat);
};

moment.fn.defaultServerFormat = function () {
  return this.format(config.serverDatetimeFormat);
};

moment.fn.defaultFullFormat = function () {
  return this.format(config.fullDateTimeFormat);
};

export default moment;
export const mmoment = memoize(function (dateString, format = 'DD.MM.YYYY') {
  return moment(dateString, format);
});
export const currentMoment = () => {
  const now = moment();
  return mmoment(now.format('DD.MM.YYYY'));
};
